var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image",style:(_vm.outerStyle)},[_c('img',{staticClass:"empty-image",style:(_vm.innerStyle),attrs:{"src":require("../../../assets/image_empty.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }